import React from "react";
import s from "../style.module.scss";
import { CtaButton } from "../../Button/CtaButton";
import { ListCheckmark } from "../../ListCheckmark";
import { Product, Benefit } from "../../../types/products.ts";
import glideImage from "../../../utils/useGlideImage.ts";
import {
  getTextStyle,
  getBackgroundStyle,
  getHeaderStyle,
} from "../../../utils/cardStyles.ts";

interface ProductCardProps {
  card: any;
  product: Product;
  index: number;
  brandName: string;
  formattedString: string;
  productPickerSection: any;
  combinedCards: any[];
  onCardClick: (product: Product) => void;
}

export const ProductCard = ({
  card,
  product,
  index,
  brandName,
  formattedString,
  productPickerSection,
  combinedCards,
  onCardClick,
}: ProductCardProps) => {
  return (
    <div
      className={`${s.productPicker__card} ${s.productPicker__card__wrapper} ${
        card.isBestValue && s.productPicker__card__bestValueCard
      }`}
      style={getBackgroundStyle(card)}
      key={index}
      onClick={() => onCardClick(product)}
    >
      <div className={s.productPicker__card}>
        <div
          className={s.productPicker__card__header}
          style={getHeaderStyle(card, combinedCards)}
          dangerouslySetInnerHTML={{ __html: card.tr_header_status_text }}
        />
        <div className={s.productPicker__content}>
          <div className={s.productPicker__content__left}>
            <img
              className={s.productPicker__content__img}
              src={glideImage(card.img.url, { w: 280, h: 260 })}
              alt={brandName}
              width={280}
              height={260}
            />
          </div>
          <div className={s.productPicker__content__right}>
            <div
              className={s.productPicker__content__title}
              style={getTextStyle(card)}
              dangerouslySetInnerHTML={{ __html: card.tr_title }}
            />
            <div
              className={s.productPicker__content__subtitle}
              style={getTextStyle(card)}
              dangerouslySetInnerHTML={{ __html: card.tr_subtitle }}
            />
            <img
              className={s.productPicker__content__img}
              src={glideImage(card.img.url, { w: 280, h: 260 })}
              alt={brandName}
              width={280}
              height={260}
            />
            <div
              className={`${s.productPicker__content__priceWrapper} ${s.productPicker__content__priceWrapperDesktop}`}
            >
              <div
                className={s.productPicker__content__price}
                style={getTextStyle(card)}
              >
                {formattedString.replace(/(0\.00|0,00|0)/, card.price)}
                <span
                  className={s.productPicker__content__price__each}
                  style={getTextStyle(card)}
                >
                  {productPickerSection?.tr_each_label}
                </span>
              </div>
              <div className={s.productPicker__content__total}>
                {formattedString.replace(/(0\.00|0,00|0)/, card.oldPrice)}
              </div>
            </div>
            <div
              className={`${s.productPicker__content__priceWrapper} ${s.productPicker__content__priceWrapperMobile}`}
            >
              <div
                className={s.productPicker__content__price}
                style={getTextStyle(card)}
              >
                {formattedString.replace(/(0\.00|0,00|0)/, card.price)}
              </div>
              <div className={s.productPicker__content__total}>
                {formattedString.replace(/(0\.00|0,00|0)/, card.oldPrice)}
              </div>
              <span
                className={s.productPicker__content__price__each}
                style={getTextStyle(card)}
              >
                {productPickerSection?.tr_each_label}
              </span>
            </div>
            {card.benefits && (
              <ul
                className={s.productPicker__content__benefitsList}
                style={getTextStyle(card)}
              >
                {card.benefits.map((benefit: Benefit, index: number) => (
                  <ListCheckmark
                    dangerousHTML={benefit.tr_benefit_text}
                    key={index}
                  />
                ))}
              </ul>
            )}
          </div>
        </div>
        <div className={s.productPicker__content__ctaWrapper}>
          <CtaButton
            text={productPickerSection.tr_cta_label}
            className={s.productPicker__content__cta}
            reversedStyles={card.isBestValue}
          />
        </div>
        <div
          className={s.productPicker__content__freeShippingLabel}
          style={getTextStyle(card)}
          dangerouslySetInnerHTML={{ __html: card.tr_shipping_label_text }}
        />
      </div>
    </div>
  );
};
